/**
 * Which login page a signed-out visitor on `pathname` belongs on. Buyers sign in
 * at /account/login; sending a buyer from their course or access link to the
 * seller /login strands them on a page for an account they don't have.
 */
const LOGIN_PAGES = ["/login", "/account/login", "/account/reset"];

export function isLoginPage(pathname: string): boolean {
  return LOGIN_PAGES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

export function loginPathFor(pathname: string): string {
  const buyer =
    pathname === "/account" ||
    pathname.startsWith("/account/") ||
    pathname.startsWith("/learn/") ||
    pathname.startsWith("/access/");
  return buyer ? "/account/login" : "/login";
}
